import "../css/app.css";
import "../css/icons.css";
import "./bootstrap";
import { createApp, h, computed, ref } from "vue";
import { createInertiaApp, usePage, router } from "@inertiajs/vue3";
import lodash from "lodash";
const { result, has } = lodash;
import store from "@/store";
import { getMobilePlatform } from "@/utils/mobilePlatform";
import { mapActions, mapState } from "vuex";
import VueGtag, { useGtag } from "vue-gtag-next";
import Vue3Toastify, { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

import Container from "@/Layouts/Container.vue";

router.on("navigate", (event) => {
    const { pageview } = useGtag();
    pageview({ page_path: event.detail.page.url });
});

// Set up axios interceptor BEFORE app initialization to ensure it's ready for all components
axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem("_token");
    // Calls to the app's API bring their own Firebase token
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = "Bearer " + token;
    }
    return config;
});

// A session that ended while this tab was open leaves a stale CSRF token: get a fresh one, retry once
axios.interceptors.response.use(undefined, async (error) => {
    const config = error.config;
    if (error.response?.status === 419 && config && !config._csrfRetried) {
        config._csrfRetried = true;
        await axios.get("/sanctum/csrf-cookie");
        return axios(config);
    }
    return Promise.reject(error);
});

createInertiaApp({
    progress: {
        // The delay after which the progress bar will appear
        // during navigation, in milliseconds.
        delay: 0,

        // The color of the progress bar.
        color: "#AEE200",

        // Whether to include the default NProgress styles.
        includeCSS: true,

        // Whether the NProgress spinner will be shown.
        showSpinner: false,
    },
    resolve: (name) => {
        const pages = import.meta.glob("./Pages/**/*.vue", { eager: true });
        let page = pages[`./Pages/${name}.vue`];
        page.default.layout = page.default.layout || Container;
        return page;
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({
            render: () => h(App, props),
            data() {
                return {
                    queue: [],
                    current: {},
                    favorites: [],
                    //siteData: computed(() => usePage().props),
                };
            },
            provide() {
                return {
                    current: this.current,
                };
            },
            computed: {
                ...mapState("user", {
                    auth: (state) => state.auth, // ✅ Moved to computed
                }),
                siteData() {
                    return usePage().props;
                },
            },
            setup() {},
            mounted() {
                axios.interceptors.response.use(
                    this.axiosResponse,
                    this.axiosError,
                );
                if (has(this.siteData, "tokens.token")) {
                    localStorage.setItem("_token", this.siteData.tokens.token);
                }

                // Signed in by token, or by the remember cookie even if the token is gone
                if (localStorage.getItem("_token") || this.siteData.loggedIn) {
                    this.getUser().catch(() => {});
                } else {
                    // Ready before a guest taps log in, without slowing the page
                    (window.requestIdleCallback || setTimeout)(() =>
                        this.$store.dispatch("user/preloadLogin"),
                    );
                }
            },

            methods: {
                ...mapActions("user", ["getUser"]),
                axiosResponse(res) {
                    try {
                        // check for response code 123 and redirect to login

                        return Promise.resolve(res);
                    } catch (e) {
                        // check for response code 123 and redirect to login
                        return Promise.resolve(res);
                    }
                },
                axiosError(err) {
                    try {
                        // check for response code 123 and redirect to login
                        if (err.response.status === 401) {
                            this.notify(
                                "Unauthenticated",
                                "Please login to continue",
                            );
                            // refresh current route.
                        } else if (err.response.status === 409) {
                            // redirect to home.
                            window.location = "/";
                        }
                        this.notify("Error", err.response.data);
                        err = Object.assign(new Error(), {
                            message: err.response.data,
                            response: err.response,
                        });
                    } catch (e) {
                        // check for response code 123 and redirect to login
                        // Will return err if something goes wrong
                    }
                    return Promise.reject(err);
                },
                playSong(id, name) {
                    const mobilePlatform = getMobilePlatform();

                    if (mobilePlatform) {
                        store.commit("current/SHOW_APP_DOWNLOAD", {
                            platform: mobilePlatform,
                            title: name || "this song",
                        });
                        return;
                    }

                    store.commit("current/HIDE_APP_DOWNLOAD");
                    axios.post("/api/_song/", { id: id }).then((response) => {
                        const mp3 = result(
                            response.data.data,
                            "sources[0].src",
                        );
                        if (has(response.data.data, "sources[0].src") && mp3) {
                            Object.keys(this.current).forEach((key) => {
                                delete this.current[key];
                            });
                            Object.assign(this.current, response.data.data);
                        } else {
                            this.notify(
                                "Error",
                                "Song is not available at the moment",
                            );
                        }
                    });
                },
            },
        });
        app.use(VueGtag, {
            isEnabled: true,
            useDebugger: false,
            property: { id: "G-60K0TQ0Z3Z", params: { send_page_view: true } },
        });
        app.use(Vue3Toastify, {
            autoClose: 3000,
            position: "top-right",
        });
        app.use(plugin);
        app.use(store);
        app.mount(el);
    },
});
